import { useBlocker } from "@tanstack/react-router";
import { BottomSheet } from "./BottomSheet";
import { Button } from "./Button";
import { Stack } from "./Stack";
import { Text } from "./Text";

/** Evaluate success at navigation time, not in the prior render's snapshot. */
export const protectChanges = (dirty: boolean, pending: boolean, canLeave?: () => boolean) => !canLeave?.() && (dirty || pending);

/** Tabs retain their form; leaving the route or browser requires a decision.
 * An in-flight mutation cannot be discarded. A known-success caller may allow
 * its intentional navigation without replaying an earlier blocked Back action. */
export function UnsavedChanges({ dirty, pending = false, canLeave }: { dirty: boolean; pending?: boolean; canLeave?: () => boolean }) {
  const shouldBlock = () => protectChanges(dirty, pending, canLeave);
  const blocker = useBlocker({ shouldBlockFn: shouldBlock, enableBeforeUnload: shouldBlock, withResolver: true });
  return <BottomSheet open={blocker.status === "blocked"} onClose={() => blocker.reset?.()} title="Keep your changes?">
    <Stack gap={3}><Text>{pending ? "A save is in progress. Stay here until it finishes." : "You have unsaved changes. Stay to save them, or discard this draft and leave."}</Text><Button onClick={() => blocker.reset?.()}>Keep editing</Button>{!pending && <Button variant="destructive" onClick={() => blocker.proceed?.()}>Discard changes and leave</Button>}</Stack>
  </BottomSheet>;
}
